import React from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';
import { useCurrentTime } from '@/util/timerHooks';

const Clock = styled.div`
  display: flex;
  flex-flow: row;
  align-items: baseline;
  justify-content: center;
  font-family: monospace;

  font-size: 5rem;
  font-weight: 600;
  line-height: 1.5;
`;

const HoursMinutes = styled.label`
  padding-right: 0.1em;
`;

const Seconds = styled.label`
  font-size: 0.5em;
`;

const WallClock = ({ date }) => {
  // Use the proper useCurrentTime hook for real-time clock display
  const currentDate = useCurrentTime({
    interval: 1000,
    precision: 'second',
  });

  return (
    <Clock>
      <HoursMinutes>{format(currentDate, 'HH:mm')}</HoursMinutes>
      <Seconds>{format(currentDate, 'ss')}</Seconds>
    </Clock>
  );
};

export default WallClock;
